// @flow

export const MapPOI = {
    "PICKUP": "PICKUP",
    "DROPOFF": "DROPOFF",
    "ORIGIN": "ORIGIN",
    "DEST": "DEST",
    "VAN": "VAN",
    "RIDER": "RIDER",
};
export type MapPOIType = $Values<typeof MapPOI>;



// WEBPACK FOOTER //
// ./src/Store/Ducks/MapData/utils.js